/**
 * VoitureMagazine — Liste des enquêtes magazine voiture. Route : /voiture/magazine
 */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight, Clock } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function VoitureMagazine() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = 'Magazine Voiture · Code 2 Roues';
    axios.get(`${API}/api/voiture/magazine`)
      .then((r) => setItems(r.data.items || []))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12" data-testid="voiture-magazine">
      <Link to="/voiture" className="inline-flex items-center gap-1.5 text-xs font-bold text-foreground/60 hover:text-foreground mb-4">
        <ArrowLeft className="w-3.5 h-3.5" /> Espace Voiture
      </Link>
      <div className="text-[11px] font-black uppercase tracking-[0.22em] mb-2" style={{ color: '#1d4ed8' }}>
        Magazine Voiture
      </div>
      <h1 className="text-3xl sm:text-4xl font-black tracking-tight text-foreground leading-tight" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
        Les enquêtes.
      </h1>
      <p className="text-sm sm:text-base text-foreground/70 mt-2 max-w-2xl">
        Long-reads écrits par des moniteurs ECSR. Sans chrono, sans score — juste de la
        lecture pour comprendre.
      </p>

      {loading && <p className="text-sm text-foreground/50 mt-8">Chargement…</p>}

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-6 sm:mt-8">
        {items.map((a) => (
          <Link
            key={a.slug}
            to={`/voiture/magazine/${a.slug}`}
            className="group rounded-xl border-2 border-border hover:border-[#1d4ed8] bg-card p-4 sm:p-5 transition-all"
            data-testid={`voiture-magazine-card-${a.slug}`}
          >
            {a.kicker && (
              <div className="text-[10px] font-black uppercase tracking-[0.18em] mb-1.5" style={{ color: '#1d4ed8' }}>
                {a.kicker}
              </div>
            )}
            <h2 className="text-base sm:text-lg font-black leading-tight text-foreground group-hover:text-[#1d4ed8] transition-colors" style={{ fontFamily: "'Playfair Display', Georgia, serif" }}>
              {a.title}
            </h2>
            {a.teaser && <p className="text-xs sm:text-sm text-foreground/60 mt-2 line-clamp-3">{a.teaser}</p>}
            <div className="flex items-center justify-between mt-3 pt-3 border-t border-border/50">
              <span className="text-[10px] text-foreground/50 inline-flex items-center gap-1">
                <Clock className="w-3 h-3" /> {a.readTimeMin || 5} min
              </span>
              <span className="text-[10px] font-bold text-[#1d4ed8] inline-flex items-center gap-0.5 group-hover:translate-x-0.5 transition-transform">
                Lire <ArrowRight className="w-3 h-3" />
              </span>
            </div>
          </Link>
        ))}
      </div>

      {!loading && items.length === 0 && (
        <p className="text-sm text-foreground/50 mt-8">Aucune enquête publiée pour le moment.</p>
      )}
    </div>
  );
}
